<template>
  <component
    :is="config.slot || 'Card'"
    style="position: relative; height: 100%"
    v-bind="(config && config.bind) || {}"
    ref="card"
  >
    <span id="TextInfo" hidden></span>
    <div
      v-if="pageConfig.loading"
      class="loading-div"
      :style="{ position: isTabs ? 'relative' : 'fixed' }"
    >
      <Button loading shape="circle" type="primary"></Button>
      <div>loading...</div>
    </div>
    <div ref="header-box">
      <slot name="header"></slot>
      <cHeader
        ref="header"
        :header="header"
        :config="header.config"
        :searchs="header.searchs"
        :btns="header.btns"
        :pageConfig="pageConfig"
        @getList="getList"
      ></cHeader>
      <slot name="header_bottom"></slot>
    </div>
    <vxeTable
      v-if="fields.length"
      :list="list"
      :fields="fields"
      :config="config"
      @checkTable="checkTable"
      :height="height"
      ref="table"
    >
      <template v-for="slot in fieldSlots" #[slot]="{ row, rowIndex, field }">
        <slot
          :name="slot"
          :row="row"
          :rowIndex="rowIndex"
          :field="field"
        ></slot>
      </template>
    </vxeTable>
    <slot name="componentContainer" :height="height"></slot>
    <div v-if="fields.length" ref="footer-box">
      <slot name="footer"></slot>
      <cFooter
        @getList="getList"
        ref="footer"
        :pageConfig="pageConfig"
        :footer="footer"
        :fields="fields"
      ></cFooter>
      <slot name="footer_bottom"></slot>
    </div>
    <template v-for="(modal, index) in modals">
      <cModal :ref="'modal-' + index" :modal="modal" :key="index">
        <template #[modal.contentTop]="{ visible, params, close }">
          <slot
            :name="modal.contentTop"
            :rowIndex="index"
            :field="modal"
            :visible="visible"
            :params="params"
            :close="close"
          ></slot>
        </template>
        <template #[modal.contentSlot]="{ visible, params, close }">
          <slot
            :name="modal.contentSlot"
            :rowIndex="index"
            :field="modal"
            :visible="visible"
            :params="params"
            :close="close"
          ></slot>
        </template>
        <template #[modal.contentBottom]="{ visible, params, close }">
          <slot
            :name="modal.contentBottom"
            :rowIndex="index"
            :field="modal"
            :visible="visible"
            :params="params"
            :close="close"
          ></slot>
        </template>
        <template
          v-for="slot in modal.slots"
          #[slot]="{ visible, params, close, row }"
        >
          <slot
            :name="slot"
            :rowIndex="index"
            :field="modal"
            :visible="visible"
            :params="params"
            :close="close"
            :row="row"
          ></slot>
        </template>
        <template #[modal.footerSlot]>
          <slot
            :name="modal.footerSlot"
            :rowIndex="index"
            :field="modal"
          ></slot>
        </template>
      </cModal>
    </template>
    <cModal :ref="'modal-KH'" :modal="KHConfig">
      <template #[KHConfig.contentSlot]="{ visible, params, close }">
        <KHGpy ref="KH" v-if="visible" :params="params" :close="close" />
      </template>
    </cModal>
    <cForm
      ref="form"
      v-if="form.fields.length"
      :fields="form.fields"
      :grid="form.grid"
      :config="form.config"
      :buttons="form.buttons"
    ></cForm>
    <slot name="form_bottom"></slot>
    <Print ref="print"></Print>
    <audio
      v-for="item in audios"
      :key="item"
      ref="audio"
      preload
      style="display: none"
    >
      <source :src="item" />
    </audio>
  </component>
</template>

<script>
import cHeader from "./component/header.vue";
import "@/api/common.js";
import cFooter from "./component/footer.vue";
import cModal from "./component/modal.vue";
import Print from "./component/print.vue";
import vxeTable from "./component/table.vue";
import cForm from "./component/form.vue";
import common from "./common.js";
import format from "@/utils/format.js";
import KHGpy from "./component/KHGpy.vue";
export default {
  provide() {
    return {
      $page: this
    };
  },
  mixins: [common],
  components: {
    vxeTable,
    cHeader,
    cFooter,
    cModal,
    cForm,
    Print,
    KHGpy
  },
  props: {
    isTabs: {
      type: Boolean,
      default: false
    },
    methods: {
      type: Object,
      default: () => ({})
    },
    modals: {
      type: Object,
      default: () => ({})
    },
    fields: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      default: () => ({ children: false, height: 640 })
    },
    header: {
      type: Object,
      default: () => ({ config: {}, searchs: [], btns: {} })
    },
    footer: {
      type: Object,
      default: () => ({})
    },
    form: {
      type: Object,
      default: () => ({ fields: [], grid: {}, config: {} })
    }
  },
  data() {
    return {
      exportLoading: false,
      tabNames: [],
      height: 0,
      list: [],
      pageConfig: {
        data: {},
        pageSize: [15, 100, 500, 1000, 5000],
        total: 0,
        size: 15,
        page: 1,
        loading: false
      },
      pageCurrent: 1,
      selectAll: [],
      format,
      formData: {},
      KHConfig: {
        config: {
          width: "1000px",
          title: this.$t("Document Cameras")
        },
        methods: {
          cancel() {
            Cam_Close();
            socket.close();
            isSocketConnect = false;
            socket = null;
            console.log("close", socket);
          }
        },
        footer: {
          show: () => false
        },
        contentSlot: "Content"
      },
      audios: [],
      audioSrc: ""
    };
  },
  computed: {
    currentFields() {
      let fields = this.fields;
      if (!Array.isArray(fields)) {
        fields = this.fields[this.fields.name] || [];
      }
      return fields;
    },
    fieldSlots() {
      return this.currentFields.reduce((a, b) => {
        if (b.slots)
          b.slots.forEach(item => {
            if (!a.includes(item)) a.push(item);
          });
        return a;
      }, []);
    },
    groupHeaders() {
      return this.currentFields.filter(item => item.slot);
    }
    // fieldSlots() {
    //   return this.fields.filter(item => item.slot);
    // },
    // groupHeaders() {
    //   return this.fields.filter(item => item.slot);
    // }
  },
  mounted() {
    // console.log(this.$route.meta.id);
    this.header &&
      this.header.searchs &&
      this.header.searchs.forEach(item => {
        if (!item.options) item.options = [];
      });
    let isArray = Array.isArray(this.fields);
    function getSlots(item, obj) {
      if (!obj) obj = item;
      item.slots = item.slot ? [item.slot] : [];
      if (item.children) {
        item.children.forEach(child => {
          if (child.slot) {
            item.slots.push(child.slot);
            obj.slots.push(child.slot);
          }
          getSlots(child, obj);
        });
      }
    }
    if (isArray) {
      this.fields.forEach((item, index) => {
        if (!item.options) item.options = [];
        this.bindRenderThis(item.header);
        this.bindRenderThis(item);
        getSlots(item);
        this.$set(this.fields, index, item);
      });
    } else {
      Object.keys(this.fields).forEach(key => {
        if (~["name", "common"].indexOf(key)) return;
        let fields = this.fields[key];
        fields.forEach((item, index) => {
          if (!isArray && item.clone && this.fields.common) {
            item = Object.assign({}, this.fields.common[item.clone], item);
          }
          this.bindRenderThis(item.header);
          this.bindRenderThis(item);
          getSlots(item);
          if (!item.options) item.options = [];
          this.$set(this.fields[key], index, item);
        });
      });
    }
    // Object.keys(this.modals).forEach(key => {
    //   let modal = this.modals[key];
    //   modal.fields &&
    //     modal.fields.forEach((item, index) => {
    //       item.options = [];
    //       item.slots = item.slot ? [item.slot] : [];
    //       // this.$set(modal.fields, index, item);
    //     });
    //   // console.log(modal);
    // });
    // console.log(this.modals);
    this.fields.forEach(item => {
      if (!item.options) item.options = [];
    });
    if (!this.form.fields.length) {
      if (Array.isArray(this.methods.list)) {
        this.list = this.methods.list;
      } else {
        if (!this.config.isGetList) this.getList();
      }
    }

    if (this.config.resize || this.config.resize === undefined) {
      this.resize();
    }
  },
  watch: {
    $route() {
      this.resize();
    }
  },
  methods: {
    playMusic(name) {
      let names = ["success", "false"];
      let index = -1;
      if (
        !this.audios.includes(name) &&
        !this.audios.includes(require("@/assets/music/" + name + ".wav"))
      ) {
        if (names.includes(name))
          this.audios.push(require("@/assets/music/" + name + ".wav"));
        else this.audios.push(name);
        console.log("新增");
        index = this.audios.length - 1;
      } else {
        if (names.includes(name))
          index = this.audios.indexOf(
            require("@/assets/music/" + name + ".wav")
          );
        else index = this.audios.indexOf(name);
        console.log("已存在");
      }
      console.log(this.audios);
      setTimeout(() => {
        console.log(this.$refs.audio[index], index);

        this.audios.forEach(
          t => this.$refs.audio[index] && this.$refs.audio[index].pause()
        );
        this.$refs.audio.currentTime = 0;
        this.$refs.audio[index].play();
      }, 500);
    },
    handleVisibleFields() {
      this.$nextTick(() => {
        let ColumnObject = this.getTable()
          .getTableColumn()
          .tableColumn.reduce((a, b) => {
            if (b.property) a[b.property] = b;
            return a;
          }, {});
        this.config.hideVisible &&
          this.config.hideVisible.forEach(t => {
            ColumnObject[t] && this.getTable().hideColumn(ColumnObject[t]);
          });
      });
    },
    toPage(routeName, data) {
      this.getTable().closeTooltip();
      this.$router.push({
        name: routeName
      });
      this.$store.dispatch("pageUrl", data);
    },
    bindRenderThis(obj) {
      if (obj && obj.render) obj.render = obj.render.bind(this);
    },
    getTable() {
      return this.$refs["table"] ? this.$refs["table"].$refs["xTable"] : {};
    },
    debounce(fn, num = 200) {
      let timeId = null;
      let time = new Date().getTime();
      return function() {
        clearTimeout(timeId);
        timeId = setTimeout(() => {
          let newTime = new Date().getTime();
          fn.call(this, arguments);
          time = newTime;
        }, num);
      };
    },
    handleResize() {
      let cardHeight = this.$refs["card"]
        ? this.$refs["card"].$el
          ? this.$refs["card"].$el.clientHeight
          : this.$refs["card"].clientHeight
        : null;
      let headerHeight =
        this.$refs["header-box"] && this.$refs["header-box"].clientHeight;
      let footerHeight =
        this.$refs["footer-box"] && this.$refs["footer-box"].clientHeight;
      let height =
        cardHeight -
        (footerHeight || 0) -
        headerHeight -
        32 -
        ~~this.config.tabHeight;
      this.height = height;
    },
    resize() {
      let MutationObserver =
        window.MutationObserver ||
        window.WebKitMutationObserver ||
        window.MozMutationObserver;
      this.$nextTick(() => {
        this.handleResize();
        window.addEventListener("resize", () => {
          this.handleResize();
        });
        let fn1 = this.debounce(this.handleResize);
        let observer = new MutationObserver(mutationList => {
          fn1();
        });
        if (this.$refs["header"]) {
          observer.observe(this.$refs["header"].$el, {
            attributes: true,
            subtree: true
          });
        }
      });
    },
    getModal(name) {
      return this.$refs["modal-" + name]
        ? this.$refs["modal-" + name][0] || this.$refs["modal-" + name]
        : {};
    },
    openLoading() {
      this.pageConfig.loading = true;
    },
    closeLoading() {
      this.pageConfig.loading = false;
    },
    checkTable(val) {
      this.selectAll = val;
      this.$emit("checkTable", val);
    },
    // loadContentMethod(data) {
    //   console.log(data);
    //   this.$emit("loadMethod", data);
    // },
    async getList(page) {
      if (page) this.pageConfig.page = page;
      this.pageConfig.loading = true;
      let searchForm = this.$refs["header"].handleFilterData();
      try {
        this.selectAll = [];
        this.list = [];

        let data = (
          await this.handleRequestMethods("list", {
            page: this.pageConfig.page,
            pageSize: this.pageConfig.size,
            ...this.pageConfig.data,
            ...searchForm
          })
        ).payload;
        let obj = {
          data,
          searchForm
        };
        this.$emit("getList", obj);
        let newList = this.handleMethods("beforeHandleList", {
          list: this.list,
          data
        });
        if (newList) data.rows = newList;
        this.list = data.rows;
        this.pageConfig.total = data.total;
        this.$nextTick(() => {
          this.handleMethods("afterHandleList", {
            list: this.list,
            data
          });
        });
      } catch (e) {
        //TODO handle the exception
        console.log(e);
      } finally {
        this.pageConfig.loading = false;
      }
    }
  }
};
</script>

<style>
.page-content {
  margin-top: 20px;
}

.ivu-btn > .ivu-icon {
  vertical-align: unset;
}

.ivu-btn > span {
  vertical-align: unset;
}

.ivu-btn-small {
  font-size: 12px !important;
}

.transition-drop-appear,
.transition-drop-enter-active,
.transition-drop-leave,
.transition-drop-leave-active {
  -webkit-animation-duration: 0.1s !important;
  animation-duration: 0.1s !important;
}

.vxe-table--render-default .vxe-cell {
  /* word-break: normal !important; */
  word-wrap: break-word !important;
}
</style>
